import { render } from "./SeoTopGamesInsights.vue?vue&type=template&id=2a8fc306&scoped=true"
import script from "./SeoTopGamesInsights.vue?vue&type=script&lang=js"
export * from "./SeoTopGamesInsights.vue?vue&type=script&lang=js"

import "./SeoTopGamesInsights.vue?vue&type=style&index=0&id=2a8fc306&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8fc306"]])

export default __exports__